import React from 'react';
import { jsx as ___EmotionJSX } from "@emotion/react";
const SVG = ({
  className = '',
  size = '24'
}) => ___EmotionJSX("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: size,
  height: size,
  className: className,
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: "2",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, ___EmotionJSX("path", {
  d: "M6 4h8a4 4 0 0 1 4 4 4 4 0 0 1-4 4H6z"
}), ___EmotionJSX("path", {
  d: "M6 12h9a4 4 0 0 1 4 4 4 4 0 0 1-4 4H6z"
}));
export default SVG;